import React from "react";
import { useSelector } from "react-redux";
import { Table } from "antd";
import { dateForHumans, numberWithCommas } from "../../utils";

function RecentDisbursement() {
  const url = "api/v2/dashboard/fetch-dashboard";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const columns = [
    {
      title: "Date",
      dataIndex: "payPaymentDate",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      sorter: (a, b) => a.payPaymentDate - b.payPaymentDate,
    },
    {
      title: "Receiver",
      dataIndex: "payReceiverName",
      sorter: (a, b) => a.payReceiverName.localeCompare(b.payReceiverName),
    },
    {
      title: "Receiver Mobile",
      dataIndex: "payReceiverMobileNo",
      sorter: (a, b) =>
        a.payReceiverMobileNo.localeCompare(b.payReceiverMobileNo),
    },
    {
      title: "Amount",
      dataIndex: "payPaymentAmount",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.payPaymentAmount - b.payPaymentAmount,
    },
    {
      title: "Type",
      dataIndex: "payPaymentType",
      sorter: (a, b) => a.payPaymentType.localeCompare(b.payPaymentType),
    },
  ];

  return (
    <div className="rounded-[.75rem] bg-white p-[1.25rem] ">
      <div className="ndovu-gradient-title text-[1rem] font-[400] leading-6 font-lexendS ">
        Recent Disbursements
      </div>
      <Table
        className="w-full mt-[1.25rem] dash-table"
        scroll={{ x: "auto" }}
        rowKey={(record) => record?.blkUid}
        columns={columns}
        dataSource={data?.recentDisbursements}
        pagination={false}
      />
    </div>
  );
}

export default RecentDisbursement;
